<script setup lang="ts">
/*

@TODO
  needs do necessary cookies
*/

import { useCookieConsent } from "@/composables/cookies/useCookieConsent";

type ConsentType =  'all' | null;

const { getConsent, setConsent } = useCookieConsent();

const bannerVisible = ref<boolean>(false);

const acceptNecessary = (): void => {
  setConsent(null);
  bannerVisible.value = false;
};

const acceptAllCookies = (): void => {
  setConsent('all');
  bannerVisible.value = false;
};

onMounted(async () => {
  const hasConsent: ConsentType = await getConsent();

  bannerVisible.value = hasConsent === null || hasConsent === false;
});
</script>

<template>
  <div
    v-show="bannerVisible"
    role="dialog"
    aria-labelledby="cookie-banner-title"
    aria-hidden="false"
    tabindex="-1"
    class="fixed bottom-16 left-4 right-4 lg:bottom-5 mx-full lg:mx-0 w-auto md:w-3/4 lg:w-1/3 max-w-md bg-brand-card text-white p-6 rounded-lg shadow-xl z-[100] flex flex-col gap-4 transition-opacity duration-500"
    :class="{ 'opacity-0': !bannerVisible, 'opacity-100': bannerVisible }"
  >
    <div>
      <p id="cookie-banner-title" class="text-sm text-center leading-4">
        Utilizamos cookies para aprimorar sua experiência de navegação, exibir anúncios ou conteúdo personalizado e analisar nosso tráfego. Ao clicar em "Aceitar todos", você concorda com nosso uso de cookies.
      </p>
    </div>

    <div class="flex gap-2">
      <button
        @click="acceptNecessary"
        class="border border-gray-500 hover:border-gray-400 text-white w-full px-4 py-2 text-sm rounded transition"
      >
        Não aceitar
      </button>
      <button
        @click="acceptAllCookies"
        class="bg-success/75 hover:bg-success text-white w-full px-4 py-2 text-sm rounded transition"
      >
        Aceitar todos
      </button>
    </div>
  </div>
</template>